import { PanelContext } from 'components/feedback/Overlay/OverlayContext'
import { useContext } from 'react'

export const usePanel = () => {
  const context = useContext(PanelContext)
  if (context === undefined) {
    throw new Error('usePanel must be used within an OverlayProvider')
  }
  return context
}
